import { render, staticRenderFns } from "./shared-document.vue?vue&type=template&id=c8c93862&scoped=true&"
import script from "./shared-document.vue?vue&type=script&lang=js&"
export * from "./shared-document.vue?vue&type=script&lang=js&"
import style0 from "./shared-document.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./shared-document.vue?vue&type=style&index=1&id=c8c93862&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c8c93862",
  null
  
)

export default component.exports